import React, { memo } from 'react'

import { string } from 'prop-types'

import marmosetViewerIcon from 'images/marmoset_viewer_icon.webp'

function ThumbMarmosetSlide({ src }) {
  return (
    <>
      <img
        alt="play icon"
        src={marmosetViewerIcon}
        width="26"
        height="26"
        loading="lazy"
        decoding="async"
        className="gallery-area-thumbs-carousel__media-icon"
      />
      <img
        className="gallery-area-thumbs-carousel__other-media-thumbnail"
        alt="thumbnail"
        src={src}
        width="90"
        height="90"
        loading="lazy"
        decoding="async"
      />
  </>
  )
}

ThumbMarmosetSlide.propTypes = {
  src: string.isRequired,
}

export default memo(ThumbMarmosetSlide)
